import * as React from "react"

function Willow(props) {
  return (
    <svg
      viewBox="0 0 231 50"
      className="willow"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M64.97 2.95h-6.56v43.49h6.56V2.95zM81.98 2.95v37.32h12.79v6.17H75.42V2.95h6.56zM107.56 2.95v37.32h12.79v6.17H101V2.95h6.56zM129.26 24.57c0 4.8 1.61 8.75 4.84 11.85 3.21 3.1 6.92 4.65 11.13 4.65 4.56 0 8.41-1.58 11.55-4.73 3.14-3.19 4.7-7.07 4.7-11.65s-1.55-8.52-4.65-11.65c-3.08-3.15-6.89-4.73-11.44-4.73s-8.35 1.58-11.46 4.73c-3.12 3.11-4.68 6.96-4.68 11.54m-6.62-.07c0-6.12 2.24-11.38 6.73-15.78 4.47-4.39 9.84-6.59 16.11-6.59s11.51 2.22 15.94 6.65c4.45 4.43 6.68 9.76 6.68 15.97 0 6.21-2.24 11.56-6.7 15.92-4.49 4.38-9.91 6.56-16.25 6.56-5.62 0-10.66-1.94-15.13-5.83-4.92-4.3-7.38-9.93-7.38-16.9zM176.64 2.95l11.32 29.07L199.79.83l11.33 31.19 12.03-29.07h7.12L210.84 49.2l-11.19-30.82-11.66 30.85-18.48-46.28h7.13zM45.87 2.95L33.84 32.02 22.52.83 10.69 32.02 5.23 18 .57 23.82l10.14 25.41 11.67-30.85L33.56 49.2 53 2.95h-7.13z"
        fill="currentColor"
      />
    </svg>
  )
}

function And(props) {
  return (
    <>
    <svg
      className={`and`}
      viewBox="0 0 113.76 132.37334"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fillOpacity={1} fillRule="nonzero" stroke="none">
        <path
          d="M280.867 849.43c13.035 11.832 28.305 19.277 45.746 22.453v120.879c-57.996-3.985-106.203-23.926-144.586-60.047-42.207-40.61-63.332-93.215-63.332-157.82 0-65.497 31.692-131.961 95.071-199.485a476.52 476.52 0 01-8.664-6.844c-2.11-1.644-3.551-2.703-4.395-3.125l-62.789-42.847C46.016 459.215 0 379.652 0 283.988c0-80.41 28.988-147.886 86.957-202.605C146.242 27.086 218.285 0 303.215 0c7.828 0 15.621.426 23.398 1.043V133.93c-10.32-2.254-20.398-3.45-30.203-3.45-39.754 0-76.222 15.93-109.351 47.875-31.903 33.125-47.829 69.547-47.829 109.309 0 27.805 10.52 54.086 31.649 78.934 21.551 24.886 61.941 57.8 121.18 98.828l8.113 5.582 26.441-32.18v220.856c-1.261 1.586-2.218 2.906-2.863 3.957l-36.086 43.519c-22.348 27.34-33.508 55.098-33.508 83.242 0 24.043 8.918 43.735 26.711 59.028"
          fill="currentColor"
          className={`${props.navStyle == 'black-white' ? `text-black` : ``} ${props.navStyle == 'white-black' ? `text-white` : ``}`}
          transform="matrix(1.33333 0 0 -1.33333 0 132.373) scale(.1)"
        />
        <path
          d="M675.516 237.137c26.027 28.605 48.547 53.914 67.312 75.843 18.93 21.887 34.098 41.196 45.762 57.762l-94.485 96.973c-15.292-19.945-31.265-39.637-47.871-59.074-16.519-19.477-34.14-39.379-52.777-59.661l-5.621-6.21-172.731 208.82c60.887 46.773 102.969 87 126.172 120.547 23.618 33.551 35.407 71.031 35.407 112.48 0 60.043-21.547 109.778-64.61 149.113-43.136 39.383-97.601 59.032-163.48 59.032-7.496 0-14.785-.348-21.981-.84V871.043a112.086 112.086 0 0020.125 1.801c28.606 0 51.336-7.86 68.367-23.621 17.028-15.715 25.477-36.254 25.477-61.52 0-22.355-6.254-41.199-18.676-56.578-5.789-7.859-15.293-17.449-28.519-28.859-13.266-11.411-30.086-24.762-50.367-40.102l-11.832-8.703a137.456 137.456 0 00-4.575 5.387v-220.86l163.028-198.363c-60.118-60.426-114.442-95.926-163.028-106.535V.203c86.508 6.871 170.106 51.824 250.707 135.059l95.7-117.469h180.171L675.516 237.137"
          fill="currentColor"
          className={`${props.navStyle == 'white-black' ? `text-black` : ``} ${props.navStyle == 'black-white' ? `text-white` : ``} `}
          transform="matrix(1.29  0 0 -1.33333 0 132.373) scale(.1)"
        />
      </g>
    </svg>
    </>
  )
}

function Blake(props) {
  return (
    <svg
      viewBox="0 0 168 47"
      fill="none"
      className="blake"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M40.97 2.95v37.32h12.79v6.17H34.4V2.95h6.57zM85.28 29.71l-6.45-14.79-6.76 14.79h13.21zm2.68 6.17H69.34L64.5 46.44h-7.07L78.95.22l20.76 46.22h-7.18l-4.56-10.56h-.01zM111.7 20.3l16.94-17.35h8.76l-19.67 19.69 19.78 23.8h-8.79l-15.66-19.35-1.36 1.35v18h-6.56V2.95h6.56V20.3zM167.37 9.12h-17.44v10.45h16.93v6.17h-16.93v14.53h17.44v6.17h-24V2.95h24v6.17zM17.44 38.53c-1.39 1.16-3.57 1.75-6.54 1.75H6.84V27.12h3.33c3.53 0 5.98.63 7.35 1.89 1.41 1.28 2.11 2.85 2.11 4.73 0 1.88-.73 3.53-2.2 4.79m6.65-11.36c-1.34-1.97-3.15-3.35-5.46-4.14 2.38-2.16 3.58-4.8 3.58-7.91 0-1.71-.37-3.4-1.1-5.07-.71-1.65-1.68-3.03-2.9-4.14-.27-.24-.55-.45-.84-.65L12.8 9.68c.53.24 1.02.52 1.43.89 1.17 1.06 1.75 2.61 1.75 4.66 0 2.05-.57 3.69-1.7 4.78-1.14 1.08-2.93 1.62-5.37 1.62H6.85v-6.18L.29 21.81v24.64h9.94c2.97 0 5.44-.27 7.41-.82 1.8-.56 3.42-1.57 4.87-3.01 2.4-2.35 3.61-5.22 3.61-8.62 0-2.59-.68-4.86-2.03-6.82"
        fill="currentColor"
      />
    </svg>
  )
}



export { Willow, And, Blake }